<template>
  <v-container grid-list-xl>
    <h1 class="display-1">Prüfungseinsatz</h1>
    <v-layout row>
      <v-flex>
        <v-select
          :items="years"
          menu-props="auto"
          item-text="Jahr"
          v-model="selectedYear"
          label="Jahr"
        />
      </v-flex>
      <v-flex>
        <v-select
          :items="standorte"
          menu-props="auto"
          item-text="Standort"
          v-model="selectedStandort"
          label="Standort"
          return-object
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn color="info" :to="{ name: 'addExam' }">Prüfung hinzufügen</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="visibleItems"
          :rows-per-page-items="rowsPerPage"
          item-key="vId"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
              <td>{{ props.item.veranstaltung }}</td>
              <td>{{ props.item.ort }}</td>
              <td>{{ formatDate(props.item.datum) }}</td>
              <td>{{ props.item.items.length || 0 }}</td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-card-text style="background-color: #eee;">
                <v-btn color="primary" @click="addNewStück(props.item)"
                  >Hinzufügen</v-btn
                >
                <v-data-table
                  hide-actions
                  :headers="itemsHeaders"
                  :items="props.item.items"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.Prüfungsset }}</td>
                    <td>{{ props.item.PrfStkNr }}</td>
                    <td>
                      <v-btn
                        flat
                        icon
                        color="indigo"
                        @click="editPrfStk(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
        <v-dialog v-model="showEditDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title
              >Prüfungsstück ändern
            </v-card-title>
            <v-card-text>
              <v-select
                :items="currentStücke"
                item-text="PrfStkNr"
                v-model="selectedStück"
                label="Prüfungsstück"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="error" @click="deleteStk()">
                Entfernen
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="saveEditStk()">
                Speichern
              </v-btn>
              <v-btn color="primary" flat @click="cancelEditStk()">
                Abbrechen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showAddDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title
              >Prüfungsstück hinzufügen
            </v-card-title>
            <v-card-text>
              <v-select
                :items="addListSets"
                item-text="Bezeichnung"
                v-model="addSelectedSet"
                label="Prüfungsset"
              />
              <v-select
                :items="currentStücke"
                item-text="PrfStkNr"
                v-model="selectedStück"
                label="Prüfungsstück"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="saveNewStk()">
                Speichern
              </v-btn>
              <v-btn color="primary" flat @click="cancelNewStk()">
                Abbrechen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import orderby from 'lodash.orderby';
import groupby from 'lodash.groupby';

export default {
  name: 'EinsatzMainPage',
  data() {
    return {
      isLoading: true,
      loadingProgress: 0,
      headers: [
        {
          text: 'Veranstaltung',
          align: 'left',
          sortable: true,
          value: 'veranstaltung'
        },
        { text: 'Ort', value: 'ort' },
        { text: 'Datum', value: 'datum' },
        { text: 'Prf-Stücke', value: 'items.length' }
      ],
      itemsHeaders: [
        { text: 'Prüfungsset', value: 'Prüfungsset' },
        { text: 'PrfStkNr', value: 'PrfStkNr' },
        { sortable: false, width: 25 }
      ],
      rowsPerPage: [10, 25, 50, { text: 'Alle', value: -1 }],
      allItems: [],
      standorte: [],
      years: [],
      selectedStandort: null,
      selectedYear: null,
      showEditDialog: false,
      currentStücke: [],
      selectedStück: null,
      currentPrüfung: null,

      showAddDialog: false,
      addListSets: [],
      addSelectedSet: null
    };
  },
  mounted() {
    let startYear = 2010;
    let currentYear = new Date().getFullYear();
    let years = [];

    while (startYear <= currentYear) {
      years.push(startYear);
      startYear++;
    }

    this.years = years.reverse();

    this.loadData(currentYear);
  },
  methods: {
    async loadData(year) {
      try {
        this.isLoading = true;
        var yearToLoad = year || new Date().getFullYear();
        var [resp] = await Promise.all([
          this.$http.get(`pruefung?year=${yearToLoad}`)
        ]);

        var tmpStandorte = [{ Standort: 'Alle', SV_ORT: 'Alle' }];
        var sendungsOrte = Object.entries(groupby(resp.body, 'SV_Ort')).map(
          m => {
            return { Standort: m[1][0].Ort, SV_ORT: m[1][0].SV_Ort };
          }
        );

        tmpStandorte.push(...orderby(sendungsOrte, ['Standort']));
        this.standorte = tmpStandorte;
        this.selectedStandort = tmpStandorte[0];

        this.selectedYear = yearToLoad;

        var grouped = groupby(resp.body, 'PrüfungsId');

        this.allItems = orderby(
          Object.entries(grouped).map(m => {
            let name = m[1][0].Veranstaltung;
            let ort = m[1][0].Ort;
            let svOrt = m[1][0].SV_Ort;
            let datum = m[1][0].DatumStart;
            let verfahren = m[1][0].verfahren;

            return {
              vId: m[0],
              verfahren: verfahren,
              veranstaltung: name,
              datum: datum,
              ort: ort,
              SV_Ort: svOrt,
              items: m[1]
            };
          }),
          o => o.datum,
          ['asc']
        );
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(date) {
      var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(date).toLocaleDateString('de-DE', options);
    },
    editPrfStk(row) {
      this.showEditDialog = true;
      this.currentPrüfung = row;

      this.$http
        .get(`pruefungsstueck?setId=${row.PrüfungssetId}`)
        .then(resp => {
          this.currentStücke = orderby(resp.data, o => o.PrfStkNr);
          var current = resp.data.find(f => f.ID === row.PrüfstückId);
          this.selectedStück = current;
        });
    },
    saveEditStk() {
      var toUpdate = {
        id: this.currentPrüfung.ID,
        stückId: this.selectedStück.ID
      };

      this.$http.put(`pruefung`, toUpdate).then(resp => {
        this.currentPrüfung.PrüfstückId = this.selectedStück.ID;
        this.currentPrüfung.PrfStkNr = this.selectedStück.PrfStkNr;
        this.selectedStück = null;
        this.showEditDialog = false;
      });
    },
    cancelEditStk() {
      this.showEditDialog = false;
      this.selectedStück = null;
    },
    addNewStück(row) {
      console.log(row);
      this.showAddDialog = true;
      this.currentPrüfung = row;

      this.$http.get(`pruefungsset?v=${row.verfahren}`).then(resp => {
        this.addListSets = resp.data;
      });
    },
    saveNewStk() {
      var toAdd = {
        prüfungsId: this.currentPrüfung.vId,
        prüfstückId: this.selectedStück.ID
      };

      this.$http.post('pruefung', toAdd).then(resp => {
        var listItem = {
          ID: resp.data,
          Prüfungsset: this.addSelectedSet.Bezeichnung,
          PrüfungssetId: this.addSelectedSet.ID,
          PrfStkNr: this.selectedStück.PrfStkNr,
          PrüfstückId: this.selectedStück.Id
        };

        this.currentPrüfung.items.push(listItem);
        this.showAddDialog = false;
      });

      console.log(toAdd);
    },
    cancelNewStk() {
      this.showAddDialog = false;
    },
    deleteStk() {
      if (confirm('Prüfungsstück aus der Prüfung entfernen?')) {
        this.$http
          .delete(`pruefung/einsatz/${this.currentPrüfung.ID}`)
          .then(resp => {
            var prf = this.allItems.find(
              f => f.vId === this.currentPrüfung.PrüfungsId.toString()
            );
            var idx = prf.items.indexOf(this.currentPrüfung);
            prf.items.splice(idx, 1);
            this.showEditDialog = false;
            this.selectedStück = null;
          });
      }
    }
  },
  watch: {
    selectedYear(newValue) {
      this.loadData(newValue);
    },
    addSelectedSet(newValue) {
      if (newValue) {
        this.$http.get(`pruefungsstueck?setId=${newValue.ID}`).then(resp => {
          this.currentStücke = orderby(resp.data, o => o.PrfStkNr);
        });
      }
    }
  },
  computed: {
    visibleItems() {
      const ort = (this.selectedStandort || {}).SV_ORT || 'Alle';
      return this.allItems.filter(f => ort === 'Alle' || f.SV_Ort === ort);
    }
  }
};
</script>
